module.exports = __webpack_public_path__ + "static/img/help_image.5ccb0064.png";